// Btn
const open = document.querySelector('.fix-zsf-open');
const close = document.querySelector('.fix-zsf-close');
const bgclose = document.querySelector('.popup-bg-cover');
const zsf = document.querySelector('.fix-zsf');
const zsfFloating = open.nextElementSibling;
const zsfx = document.querySelector('.fix-zsf-close');
const zsfbg = document.querySelector('.popup-bg-cover');

open.addEventListener('click', () => {
	open.classList.toggle('zsf-open');
	zsfFloating.classList.toggle('zsf-open');
	zsfx.classList.toggle('zsf-open');
	zsfbg.classList.toggle('zsf-open');
});
close.addEventListener('click', () => {
	open.classList.remove('zsf-open');
	zsfFloating.classList.remove('zsf-open');
	zsfx.classList.remove('zsf-open');
	zsfbg.classList.remove('zsf-open');
});
bgclose.addEventListener('click', () => {
	open.classList.remove('zsf-open');
	zsfFloating.classList.remove('zsf-open');
	zsfx.classList.remove('zsf-open');
	zsfbg.classList.remove('zsf-open');
});

document.addEventListener("DOMContentLoaded", function (e) {
	// window.addEventListener('DOMContentLoaded', function() {makeElementsWithFacilityInfo();})

	var ZenSearchFroms = document.querySelectorAll('.ZenSearchFrom');

	ZenSearchFroms.forEach((ZenSearchFrom) => {
		ZenSearchFrom.addEventListener('submit', function (event) {
			var checkInDate = ZenSearchFrom.querySelector('.checkin_date').value;
			if (checkInDate == "") {
				alert("チェックインは必須です");
				event.preventDefault();
				return;
			}
			var nights = ZenSearchFrom.querySelector('.numOfNights').value;
			var checkInDate = ZenSearchFrom.querySelector('.checkin_date').value;
			var checkInDateArr = [];
			checkInDateArr[0] = checkInDate.substr(0, 4);
			checkInDateArr[1] = checkInDate.substr(4, 2);
			checkInDateArr[2] = checkInDate.substr(6, 2);

			var checkInForCalc = new Date(checkInDateArr[0],
			parseInt(checkInDateArr[1], 10)-1, checkInDateArr[2]);
			checkInForCalc.setDate(checkInForCalc.getDate());
			var checkIn = checkInForCalc.getFullYear() + ('0' +(checkInForCalc.getMonth() + 0)).slice(-2) + ('0' + checkInForCalc.getDate()).slice(-2);

			var checkInDate = ('0' + checkInForCalc.getDate()).slice(-2);
			var checkInMonthYear = ('0' +(checkInForCalc.getMonth() + 0)).slice(-2) + checkInForCalc.getFullYear();

			var checkOutForCalc = new Date(checkInDateArr[0],
			parseInt(checkInDateArr[1], 10)-1, checkInDateArr[2]);
			checkOutForCalc.setDate(checkOutForCalc.getDate()+ parseInt(nights, 10));
			var checkOut = checkOutForCalc.getFullYear() + ('0' +(checkOutForCalc.getMonth() + 0)).slice(-2) + ('0' + checkOutForCalc.getDate()).slice(-2);

			var checkOutDate = ('0' + checkOutForCalc.getDate()).slice(-2);
			var checkOutMonthYear = ('0' +(checkOutForCalc.getMonth() + 0)).slice(-2) + checkOutForCalc.getFullYear();

			var input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('name', 'checkInDate');
			input.setAttribute('value', checkInDate);
			ZenSearchFrom.appendChild(input);

			var input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('name', 'checkInMonthYear');
			input.setAttribute('value', checkInMonthYear);
			ZenSearchFrom.appendChild(input);

			var input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('name', 'checkOutDate');
			input.setAttribute('value', checkOutDate);
			ZenSearchFrom.appendChild(input);

			var input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('name', 'checkOutMonthYear');
			input.setAttribute('value', checkOutMonthYear);
			ZenSearchFrom.appendChild(input);

			setAttributeParams();
		});
	});


	//チェックイン日のカレンダーを作成
	var today = new Date();
	var holiday = '';
	var endMin = new Date(today);
	endMin.setDate(endMin.getDate() + 1);
	var startMax = new Date(today);
	startMax.setMonth(startMax.getMonth() + 13);
	var endMax = new Date(today);
	endMax.setMonth(endMax.getMonth() + 13);
	endMax.setDate(endMax.getDate() + 1);
	var arrayHoliday = Object.values(holiday);

	ZenSearchFroms.forEach((ZenSearchFrom) => {
		var checkin = new Pikaday({
			field: ZenSearchFrom.querySelector('.checkin_date_calendar'),
			format: 'YYYYMMDD',
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths:true,
			minDate: new Date(today),
			maxDate: startMax,
			yearSuffix: '年',
			showMonthAfterYear: true,
			events: arrayHoliday,i18n: {
				previousMonth : "前の月",
				nextMonth : "次の月",
				months : ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],
				weekdays : ["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],
				weekdaysShort : ["日","月","火","水","木","金","土"]
			},
			onSelect: function(date) {
				var day = ('0' + (date.getDate())).slice(-2);
				var month = ('0' + (date.getMonth() +1)).slice(-2);
				var year = date.getFullYear();
				var checkinDate = ZenSearchFrom.querySelector('.checkin_date');
				checkinDate.value = String(year) + String(month) + String(day);
			},
			toString: function(date, format) {
				var day = ('0' + (date.getDate())).slice(-2);
				var month = ('0' + (date.getMonth() +1)).slice(-2);
				var year = date.getFullYear();
				// return String(year) + String(month) + String(day);},
				return String(year) + '/' + String(month) + '/' + String(day);
			},
			parse: function(dateString, format) {
				var day = parseInt(parts[0], 10);
				var month = parseInt(parts[1], 10)-1;
				var year = parseInt(parts[2], 10);
				return new Date(year, month, day);
			}
		})
	});

});


// Stepper 1-99
function plus(chk){
	chk.value++;
	if (chk.value==99) {chk.value=98}
}
function minus(chk){
	chk.value--;
	if (chk.value==0) {chk.value=1}
}
// Stepper 0-99
function plus1(chk){
	chk.value++;
	if (chk.value==99) {chk.value=98}
}
function minus1(chk){
	chk.value--;
	if (chk.value==0) {chk.value=0}
}

